import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Folder2Open } from 'react-bootstrap-icons'
import { useNavigate, useParams } from 'react-router-dom'

export default observer(function SidebarFolderItem({ folder }) {
  const { folder_id } = useParams()
  const [isSelected, setIsSelected] = useState(!!folder_id && folder.id === folder_id)
  const [hoverFolder, setHoverFolder] = useState(false)
  const navigate = useNavigate()


  useEffect(() => {
    if (+folder_id === +folder.id) {
      setIsSelected(true)
      setHoverFolder(true)
    } else {
      setIsSelected(false)
      setHoverFolder(false)
    }
  }, [folder, folder_id])

  return (
    <button
      onMouseEnter={() => setHoverFolder(true)}
      onMouseLeave={() => {
        if (isSelected) return
        setHoverFolder(false)
      }}
      className={`flex gap-2 items-center w-full rounded-lg py-1 pl-4 ${hoverFolder ? 'bg-rb-grey dark:bg-rb-dark-mode-lighter' : ''}`}
      onClick={() => {
        setIsSelected(!isSelected)
        setHoverFolder(true)
        navigate(`/project_manager/campaigns/clients/${folder.client_id}/folders/${folder.id}`, {state: folder})
      }}
    >
      <Folder2Open className="rb-text-muted" style={{ color: hoverFolder ? '#EAB308' : undefined }} />
      <span className='truncate max-w-[120px] dark:text-white'>{folder.name}</span>
    </button>
  )
})
